(function() {
  var Controller,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  Controller = App.loadClass('core::Angular/Controller');

  exports.PicsController = (function(superClass) {
    extend(PicsController, superClass);

    function PicsController(scope, transitions, data, modal1) {
      this.scope = scope;
      this.transitions = transitions;
      this.data = data;
      this.modal = modal1;
      this.launchAddPicDialog = bind(this.launchAddPicDialog, this);
      this.turnOffBigPicture = bind(this.turnOffBigPicture, this);
      this.displayBigPicture = bind(this.displayBigPicture, this);
      this.scope.title = 'Pics';
      this.scope.fullpage = true;
      this.scope.absolute_errors = true;
      this.scope.bigPicture = null;
      this.scope.displayBigPicture = this.displayBigPicture;
      this.scope.turnOffBigPicture = this.turnOffBigPicture;
      this.scope.launchAddPicDialog = this.launchAddPicDialog;
      this.loadScopeData(this.data.getPics(), 'pics');
    }

    PicsController.prototype.displayBigPicture = function(pic) {
      return this.scope.bigPicture = pic;
    };

    PicsController.prototype.turnOffBigPicture = function() {
      return this.scope.bigPicture = null;
    };

    PicsController.prototype.launchAddPicDialog = function() {
      var modal;
      modal = this.modal.open({
        windowClass: 'modal-width',
        templateUrl: 'backend/admin/pics/load-layout-add-pic-dialog',
        controller: 'Funsies.Controllers.AddPicController'
      });
      return modal.result.then((function(_this) {
        return function() {
          return _this.loadScopeData(_this.data.getPics(), 'pics');
        };
      })(this));
    };

    return PicsController;

  })(Controller);

}).call(this);
